<template>
  <section id="research" class="research-section">
    <h2>Research & Innovations</h2>
    <div class="highlight-box">
      <p>Our research focuses on developing innovative treatments for psoriasis through understanding its molecular mechanisms and exploring new therapeutic approaches.</p>
    </div>
    <div class="grid-container">
      <div class="grid-item">
        <h3>Current Projects</h3>
        <ul>
          <li>Novel Biological Therapies</li>
          <li>Genetic Factors in Psoriasis</li>
          <li>Treatment Response Prediction</li>
        </ul>
      </div>
      <div class="grid-item">
        <h3>Publications</h3>
        <ul>
          <li>30+ Peer-reviewed Articles</li>
          <li>5 Book Chapters</li>
          <li>Multiple Clinical Guidelines</li>
        </ul>
      </div>
      <div class="grid-item">
        <h3>Collaborations</h3>
        <ul>
          <li>International Research Centers</li>
          <li>Clinical Trial Networks</li>
          <li>Industry Partnerships</li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ResearchSection'
}
</script>

<style scoped>
.research-section {
  padding: 60px 20px;
}

.highlight-box {
  background-color: #f8f9fa;
  padding: 30px;
  margin: 30px 0;
  border-radius: 8px;
  text-align: center;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  margin-top: 40px;
}

.grid-item {
  background-color: white;
  padding: 25px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.grid-item:hover {
  transform: translateY(-5px);
}

.grid-item h3 {
  color: #2c3e50;
  margin-bottom: 20px;
  text-align: center;
}

.grid-item ul {
  list-style-type: none;
  padding: 0;
}

.grid-item li {
  margin: 12px 0;
  padding-left: 25px;
  position: relative;
}

.grid-item li:before {
  content: "•";
  color: #42b983;
  position: absolute;
  left: 0;
}
</style>
